module.exports = __webpack_public_path__ + "media/img/pages/companies/ckw-axpo-group-7bf1abc7c0bee546e698cf3de4a59ab5.png";